import { render, staticRenderFns } from "./Protocal.vue?vue&type=template&id=355c141e&scoped=true&"
import script from "./Protocal.vue?vue&type=script&lang=js&"
export * from "./Protocal.vue?vue&type=script&lang=js&"
import style0 from "./Protocal.vue?vue&type=style&index=0&id=355c141e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "355c141e",
  null
  
)

export default component.exports